// deps
import React, { memo } from "react";

// internal deps
import {
    SavingsLineItemRightSection as RightSection,
    SavingsLineItemButtonType,
    SavingsRightSectionType,
} from "@swiggy-private/cart-types";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { default as ArrowRight } from "@swiggy-private/dls-web-icons/dist/web/generic/chevronRight/12";
import { default as Tick } from "@swiggy-private/dls-web-icons/dist/web/generic/tick/16";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

// styles
import { ButtonTextWrapper, IconWrapper, OneTapButton, RightChevronWrapper } from "./SavingsLineItem.style";

const SavingsLineItemRightSection = ({ rightSection }: { rightSection: RightSection }) => {
    if (rightSection?.type === SavingsRightSectionType.BUTTON) {
        const isSecondaryButton = rightSection?.buttonType === SavingsLineItemButtonType.SECONDARY;
        const color = isSecondaryButton ? "text_Med_Emphasis" : "primary";

        return (
            <OneTapButton isSecondaryButton={isSecondaryButton} color={rightSection.color}>
                <ButtonTextWrapper
                    variant="V2.body3.neutral.bold"
                    color={color}
                    isSecondaryButton={isSecondaryButton}
                    textColor={rightSection.color}
                >
                    {rightSection?.value}
                </ButtonTextWrapper>
            </OneTapButton>
        );
    } else if (rightSection?.type === SavingsRightSectionType.LABEL) {
        return (
            <IconWrapper>
                <span>
                    <GenericIcon Icon={Tick} strokeColor="special_positive" />
                </span>
                <Text variant="V2.body3.neutral.medium" color="special_positive">
                    {rightSection?.value}
                </Text>
            </IconWrapper>
        );
    } else {
        return (
            <RightChevronWrapper>
                <GenericIcon Icon={ArrowRight} />
            </RightChevronWrapper>
        );
    }
};

export default memo(SavingsLineItemRightSection);
